import { ReactComponent as iconDropdown } from "../../Assets/icon-dropdown/blue.svg";
import { ReactComponent as iconEflow } from "../../Assets/icon-eflow.svg";
import { ReactComponent as iconEflowWhite } from "../../Assets/icon-eflow-white.svg";
import { ReactComponent as iconLagerstyring } from "../../Assets/icon-lagerstyring.svg";
import { ReactComponent as iconWebshop } from "../../Assets/icon-webshop.svg";
import { ReactComponent as iconLock } from "../../Assets/icon-lock.svg";
import { ReactComponent as iconUnlocked } from "../../Assets/icon-unlocked.svg";
import { ReactComponent as iconSpinner } from "../../Assets/icon-spinner.svg";
import { ReactComponent as iconEmployee } from "../../Assets/icon-employee.svg";
import { ReactComponent as menuEmployee } from "../../Assets/menu/menu-employee.svg";
import { ReactComponent as menuAccounts } from "../../Assets/menu/menu-accounts.svg";
import { ReactComponent as menuAdministration } from "../../Assets/menu/menu-administration.svg";
import { ReactComponent as menuDistributors } from "../../Assets/menu/menu-distributors.svg";
import { ReactComponent as menuUsers } from "../../Assets/menu/menu-users.svg";

import { ReactComponent as menuEmployeeActive } from "../../Assets/menu/menu-employee-active.svg";
import { ReactComponent as menuAccountsActive } from "../../Assets/menu/menu-accounts-active.svg";
import { ReactComponent as menuAdministrationActive } from "../../Assets/menu/menu-administration-active.svg";
import { ReactComponent as menuDistributorsActive } from "../../Assets/menu/menu-distributors-active.svg";
import { ReactComponent as menuUsersActive } from "../../Assets/menu/menu-users-active.svg";

import { ReactComponent as iconAdd } from "../../Assets/icon-add.svg";
import { ReactComponent as iconSearch } from "../../Assets/icon-search.svg";
import { ReactComponent as iconEdit } from "../../Assets/icon-edit.svg";
import { ReactComponent as iconArrowRight } from "../../Assets/icon-arrow-right.svg";
import { ReactComponent as iconDelete } from "../../Assets/icon-delete.svg";
import { ReactComponent as iconStop } from "../../Assets/icon-stop.svg";
import { ReactComponent as iconCross } from "../../Assets/icon-cross.svg";
import { ReactComponent as iconClose } from "../../Assets/icon-close.svg";
import { ReactComponent as iconExternal } from "../../Assets/icon-external-link.svg";
import { ReactComponent as iconCheckmark } from "../../Assets/icon-checkmark.svg";

import { ReactComponent as iconWorkflow } from "../../Assets/workflow.svg";
import { ReactComponent as iconInventory } from "../../Assets/inventory.svg";
import { ReactComponent as iconNotification } from "../../Assets/icon-notification.svg";
import { ReactComponent as iconCart } from "../../Assets/icon-cart.svg";
import { ReactComponent as iconSSO } from "../../Assets/icon-sso.svg";
import { ReactComponent as arrowDown } from "../../Assets/arrow-down.svg";
import { ReactComponent as iconDownload } from "../../Assets/icon-download.svg";
import { ReactComponent as bulletTrans } from "../../Assets/bullet-trans.svg";
import { ReactComponent as iconUpdatePassword } from "../../Assets/icon-update-password.svg";
import { ReactComponent as iconEflowFull } from "../../Assets/icon-eflow-full.svg";

const iconList = {
  iconDropdown,
  iconEflow,
  iconEflowWhite,
  iconEflowFull,
  iconLagerstyring,
  iconWebshop,
  iconLock,
  iconUnlocked,
  iconSpinner,
  iconEmployee,
  menuEmployee,
  menuAccounts,
  menuAdministration,
  menuDistributors,
  menuUsers,
  iconAdd,
  iconSearch,
  iconEdit,
  iconArrowRight,
  menuEmployeeActive,
  menuAccountsActive,
  menuAdministrationActive,
  menuDistributorsActive,
  menuUsersActive,
  iconDelete,
  iconStop,
  iconCross,
  iconClose,
  iconExternal,
  iconCheckmark,
  iconWorkflow,
  iconInventory,
  iconNotification,
  iconCart,
  iconSSO,
  arrowDown,
  iconDownload,
  bulletTrans,
  iconUpdatePassword,
};

export default iconList;
